
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patients/[[...params]]",
      function () {
        return require("private-next-pages/patients/[[...params]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patients/[[...params]]"])
      });
    }
  